import { http, HttpResponse } from 'msw'

import { allKonvives } from 'app/mocks/data/users/konvives'

import {
    api,
    isNumeric,
    queryIntoArrayNumber,
    SEARCH_PARAM_LIMIT,
    SEARCH_PARAM_OFFSET,
} from 'app/utils/constants'
import { searchParametersKonviveApi } from 'app/utils/users/konvive'

export const getAllKonvives = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.users.konvives.LIST}`,
    ({ request }) => {
        const { searchParams } = new URL(request.url)
        const limitQuery = searchParams.get(SEARCH_PARAM_LIMIT)
        const offsetQuery = searchParams.get(SEARCH_PARAM_OFFSET)

        const managerIdsFilter = searchParams.get(
            searchParametersKonviveApi.MANAGERS,
        )

        let allKonvivesFiltered = allKonvives

        // Manager filter
        if (managerIdsFilter) {
            const managerIdsSplit = queryIntoArrayNumber(managerIdsFilter)

            allKonvivesFiltered = allKonvivesFiltered.filter((konvive) =>
                managerIdsSplit.includes(konvive.client.id),
            )
        }

        // Pagination
        const limit = isNumeric(limitQuery) ? Number(limitQuery) : 10
        const offset = isNumeric(offsetQuery) ? Number(offsetQuery) : 0

        const limitArray =
            allKonvivesFiltered.length > limit
                ? offset + limit
                : allKonvivesFiltered.length

        const results = allKonvivesFiltered.slice(offset, limitArray)

        const next =
            offset + results.length < allKonvivesFiltered.length
                ? 'again'
                : undefined

        return HttpResponse.json({
            count: allKonvivesFiltered.length,
            next,
            results,
        })
    },
)
